import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { ApolloClient, InMemoryCache, HttpLink, ApolloProvider } from '@apollo/client';
import classnames from 'classnames';
import fetch from 'cross-fetch';
import React from 'react';
import DatePicker$2 from './GregorianCalendar/GregorianCalendar.js';
import DatePicker$1 from './RetailCalendar/RetailCalendar.js';

var _excluded = ["autoOk", "className", "data-testid", "disabled", "error", "errorText", "format", "hintText", "highlight", "id", "label", "location", "onError", "onUpdate", "placeholder", "required", "type", "value"];
function RawDatePicker(_ref) {
  var _classnames;
  var _ref$autoOk = _ref.autoOk,
    autoOk = _ref$autoOk === void 0 ? true : _ref$autoOk,
    className = _ref.className,
    dataTestId = _ref['data-testid'],
    disabled = _ref.disabled,
    error = _ref.error,
    errorText = _ref.errorText,
    format = _ref.format,
    hintText = _ref.hintText,
    _ref$highlight = _ref.highlight,
    highlight = _ref$highlight === void 0 ? false : _ref$highlight,
    id = _ref.id,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Date' : _ref$label,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? 'bottom-left' : _ref$location,
    onError = _ref.onError,
    onUpdate = _ref.onUpdate,
    placeholder = _ref.placeholder,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'gregorian' : _ref$type,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // Initialize Apollo Client
  var client = {};
  if (type === 'retail') {
    // we dont need or want to establish an apollo client when its the gregorian calendar
    client = new ApolloClient({
      cache: new InMemoryCache(),
      link: new HttpLink({
        fetch: fetch,
        uri: 'https://graphqlcanvas.dev.target.com/graphql_canvas'
      }),
      uri: 'https://graphqlcanvas.dev.target.com/graphql_canvas'
    });
  }
  var finalClasses = classnames('C-DatePicker', (_classnames = {}, _defineProperty(_classnames, "--location-".concat(location), location), _defineProperty(_classnames, "--type-".concat(type), type), _classnames), className);
  if (otherProps['onChange']) {
    console.error('Hey Canvas User! DatePicker does not support onChange events, please use onUpdate.');
    return;
  }
  if (type === 'retail' && onError) {
    console.error('Hey Canvas User! The retail DatePicker does not support onError.');
    return;
  }
  if (type === 'retail' && format) {
    console.error('Hey Canvas User! The retail DatePicker does not support the format prop.');
    return;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: finalClasses,
    "data-testid": dataTestId
  }, type === 'retail' ? /*#__PURE__*/React.createElement(ApolloProvider, {
    client: client
  }, /*#__PURE__*/React.createElement(DatePicker$1, _extends({
    highlight: highlight,
    "data-testid": dataTestId,
    id: id,
    label: label,
    placeholder: placeholder,
    autoOk: autoOk,
    required: required,
    disabled: !!disabled // not undefined only true/false
    ,
    value: value,
    error: error,
    errorText: errorText,
    hintText: hintText,
    onChange: function onChange() {} // prevents warning, we're smarter than react
    ,
    onUpdate: onUpdate
  }, otherProps))) : /*#__PURE__*/React.createElement(DatePicker$2, _extends({
    autoOk: autoOk,
    "data-testid": dataTestId,
    disabled: !!disabled // not undefined only true/false
    ,
    error: error,
    errorText: errorText,
    format: format,
    highlight: highlight,
    hintText: hintText,
    id: id,
    label: label,
    onChange: function onChange() {} // prevents warning, we're smarter than react
    ,
    onError: onError,
    onUpdate: onUpdate,
    placeholder: placeholder,
    required: required,
    value: value
  }, otherProps)));
}
RawDatePicker.displayName = 'DatePicker';
var DatePicker = /*#__PURE__*/React.memo(RawDatePicker);

export { DatePicker as default };
